"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var validateInterfaceNo = function validateInterfaceNo(rule, value, callback) {
      if ((0, _validate.validRule3)(value)) {
        callback(new Error(_this.$t('interfaceInfo.error.interfaceNo')));
      } else if (_this.errorKeys.indexOf('interfaceNo') >= 0) {
        callback(new Error(_this.errorInfo['interfaceNo']));
        _this.resetError('interfaceNo');
      } else {
        callback();
      }
    };
    var validateInterfaceName = function validateInterfaceName(rule, value, callback) {
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('interfaceInfo.error.interfaceName')));
      } else if (_this.errorKeys.indexOf('interfaceName') >= 0) {
        callback(new Error(_this.errorInfo['interfaceName']));
        _this.resetError('interfaceName');
      } else {
        callback();
      }
    };
    return {
      pageName: 'interfaceinfo',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        interfaceNo: '',
        interfaceName: ''
      },
      dialogStatus: 'create',
      form: {
        interfaceInfoPk: '',
        interfaceNo: '',
        interfaceName: '',
        remark: ''
      },
      initForm: {
        interfaceInfoPk: '',
        interfaceNo: '',
        interfaceName: '',
        remark: ''
      },
      rules: {
        interfaceNo: [{
          required: true,
          trigger: ['change'],
          validator: validateInterfaceNo
        }],
        interfaceName: [{
          required: true,
          trigger: ['change'],
          validator: validateInterfaceName
        }]
      },
      errorKeys: [],
      errorInfo: {}
    };
  },
  computed: {
    stateBtn: function stateBtn() {
      return function (state) {
        if (state.toLowerCase() === 'enable') {
          state = 'disabled';
        } else {
          state = 'enable';
        }
        return this.$t("common.".concat(state));
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          interfaceNo: this.searchVal.interfaceNo,
          interfaceName: this.searchVal.interfaceName
        }
      };
      this.listLoading = true;
      this.$api.interfaceInfo.getInterfaceList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    create: function create() {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.form = {
        interfaceInfoPk: '',
        interfaceNo: '',
        interfaceName: '',
        remark: ''
      };
      this.initForm = {
        interfaceInfoPk: '',
        interfaceNo: '',
        interfaceName: '',
        remark: ''
      };
      this.isShowModel = true;
      this.$nextTick(function () {
        _this3.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this4 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.interfaceInfoPk;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this4.isShowModel = true;
        _this4.$nextTick(function () {
          _this4.$refs['dataForm'].clearValidate();
        });
      });
    },
    getDetail: function getDetail() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.isLoading = true;
        _this5.$api.interfaceInfo.getInterfaceDetail(_this5.currentId).then(function (res) {
          _this5.isLoading = false;
          var _res$data = res.data,
            interfaceInfoPk = _res$data.interfaceInfoPk,
            interfaceNo = _res$data.interfaceNo,
            interfaceName = _res$data.interfaceName,
            remark = _res$data.remark;
          _this5.form = {
            interfaceInfoPk: interfaceInfoPk,
            interfaceNo: interfaceNo,
            interfaceName: interfaceName,
            remark: remark
          };
          _this5.initForm = {
            interfaceInfoPk: interfaceInfoPk,
            interfaceNo: interfaceNo,
            interfaceName: interfaceName,
            remark: remark
          };
          resolve(_this5.form);
        }).catch(function () {
          _this5.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    switchState: function switchState(row, index) {
      var _this6 = this;
      if (row.state.toLowerCase() === 'enable') {
        this.$confirm(this.$t('common.confirm5'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this6.isLoading = true;
          _this6.$api.interfaceInfo.disabledInterface(row.interfaceInfoPk).then(function (res) {
            _this6.$set(_this6.list[index], 'state', 'DISABLED');
            _this6.isLoading = false;
          }).catch(function () {
            // this.$message.error('删除失败')
            _this6.isLoading = false;
          });
        }).catch(function () {});
      } else {
        this.$confirm(this.$t('common.confirm6'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this6.isLoading = true;
          _this6.$api.interfaceInfo.enableInterface(row.interfaceInfoPk).then(function (res) {
            _this6.$set(_this6.list[index], 'state', 'ENABLE');
            _this6.isLoading = false;
          }).catch(function () {
            // this.$message.error('删除失败')
            _this6.isLoading = false;
          });
        }).catch(function () {});
      }
    },
    deleteItem: function deleteItem(row) {
      var _this7 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this7.isLoading = true;
        _this7.$api.interfaceInfo.deleteInterface([row.interfaceInfoPk]).then(function (res) {
          _this7.isLoading = false;
          _this7.refreshData();
        }).catch(function () {
          _this7.isLoading = false;
        });
      }).catch(function () {});
    },
    saveItem: function saveItem() {
      var _this8 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this8.isLoading = true;
        _this8.$api.interfaceInfo.saveInterface(_this8.form).then(function (res) {
          _this8.isLoading = false;
          _this8.isShowModel = false;
          _this8.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this8.resetError();
            err.errorInfos.forEach(function (item) {
              _this8.errorKeys.push(item.key);
              _this8.errorInfo[item.key] = item.errMsg;
            });
            _this8.$refs['dataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this8.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    }
  }
};